import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#4A0E26] text-white pt-16 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-12 border-b border-white/10 items-start">
          {/* Brand Info */}
          <div className="md:col-span-6 space-y-2">
            <Link to="/" className="inline-block">
              <span className="font-serif text-3xl font-normal tracking-wide text-white">
                IESHIA <span className="italic font-light">DANIELLE</span>
              </span>
            </Link>
            <p className="text-white/80 font-serif italic text-lg">
              From burnout to becoming.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-6 flex flex-wrap gap-x-6 gap-y-3 justify-start md:justify-end text-xs uppercase tracking-widest font-semibold text-white/90">
            <Link to="/about" className="hover:text-white/70 transition-colors">
              About
            </Link>
            <Link to="/shop" className="hover:text-white/70 transition-colors">
              Shop
            </Link>
            <Link to="/book" className="hover:text-white/70 transition-colors">
              Book Ieshia
            </Link>
            <Link
              to="/podcast"
              className="hover:text-white/70 transition-colors"
            >
              Podcast
            </Link>
          </div>
        </div>

        {/* Bottom copyright + policy links */}
        <div className="pt-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs text-white/50 tracking-wider">
          <p>
            © {new Date().getFullYear()} Ieshia Danielle. All rights reserved.
          </p>
          <div className="flex flex-wrap gap-x-5 gap-y-2 justify-start sm:justify-end text-white/50">
            <Link
              to="/privacy"
              className="hover:text-white/70 transition-colors"
            >
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-white/70 transition-colors">
              Terms
            </Link>
            <Link
              to="/refunds"
              className="hover:text-white/70 transition-colors"
            >
              Refunds
            </Link>
            <Link
              to="/product-license"
              className="hover:text-white/70 transition-colors"
            >
              License
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
